import React from "react";

import formatDate from "utils/DateUtil";
import "./redeem-item.css";
import {
  REDEEM_REJECT_REASON,
  REDEEM_STATUS,
  REDEEM_STATUS_CODE,
  REDEEM_STATUS_LABEL,
  RedeemRequest,
  RedeemStatus,
} from "types/redeem";

interface Props {
  request: RedeemRequest;
  /** Only for a row with no settlementTokenSymbol of its own. */
  fallbackTokenSymbol: string;
}

const STATUS_BADGE: Record<RedeemStatus, string> = {
  0: `● ${REDEEM_STATUS_LABEL.PENDING}`,
  1: `● ${REDEEM_STATUS_LABEL.INREVIEW}`,
  2: `● ${REDEEM_STATUS_LABEL.INPROGRESS}`,
  3: `✓ ${REDEEM_STATUS_LABEL.APPROVED}`,
  4: `✕ ${REDEEM_STATUS_LABEL.REJECTED}`,
};

function RedeemItem({ request, fallbackTokenSymbol }: Props) {
  const { amount, status, createdAt, reason, settlementTokenSymbol } = request;
  const statusClass = REDEEM_STATUS[status].toLowerCase();
  console.log(`RedeemItem reason: `, reason);

  return (
    <div className={`rdm-item rdm-item--${statusClass.split(" ").join("-")}`}>
      <div className="rdm-item__row">
        <span className="rdm-item__date">
          {formatDate(new Date(createdAt))}
        </span>
        <span className="rdm-item__amount">
          {amount.toFixed(2)} {settlementTokenSymbol ?? fallbackTokenSymbol}
        </span>
        <span className={`rdm-item__badge rdm-item__badge--${statusClass.split(" ").join("-")}`}>
          {STATUS_BADGE[status]}
        </span>
      </div>

      {status === REDEEM_STATUS_CODE.REJECTED && reason !== undefined && (
        <p className="rdm-item__reason">{REDEEM_REJECT_REASON[reason]}</p>
      )}
    </div>
  );
}

export default RedeemItem;
